import type { AtomicAsset } from "../types";
import { getBackingInfo } from "../utils/backing";

export function BackedBadge({ asset }: { asset: AtomicAsset }) {
  const backing = getBackingInfo(asset);
  if (!backing) return null;

  return (
    <span className="backed-badge" title="Redeemable by burning this NFT">
      🔒 {backing.amount} {backing.symbol}
    </span>
  );
}
